import type { FaireProductEntity } from "../../entity_types/product";

export const p_fp3axdhudg: FaireProductEntity = {
  token: "p_fp3axdhudg",
  type: "product",
  name: "Headache Relief Roller | Essential Oil Roll on",
  brandName: "Soulistic Root - Essential Oils & Self Care Gifts",
  imageUrl:
    "https://cdn.faire.com/fastly/af3f380ff395cd16edf7f0be1fe94ef2fba82448ec1414891fcb3f8e2f146713.jpeg",
  priceDollars: 7.75,
  description: "",
  categoryTokens: ["cat_accessories"],
  tags: [],
  meta: {
    source: "mock",
    importedAt: "2026-03-24T13:23:30Z",
    importedBy: "retailerThemesSeed-migration",
  },
  freeShipping: true,
  brandAvatarUrl:
    "https://cdn.faire.com/fastly/8bf8762345387bfdf97ace4eb5bd1961513d7c88fea8feac655932ee8ce23658.jpeg",
  weight: 0.5,
  dimensions: {
    width: 4,
    height: 4,
    depth: 2,
  },
  inStock: true,
};
